/**
 * Shared CSS-grid layout for Catalog tiles. Per Ean's 2026-06-09 design lock:
 * `repeat(auto-fill, minmax(280px, 1fr))` keeps cards a consistent minimum
 * width while wrapping naturally on narrower viewports.
 */

import type React from 'react';

export function TileGrid({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '14px',
      }}
    >
      {children}
    </div>
  );
}
